import { gql } from "@apollo/client";

// Callers refetch getReviewStepQuestions after it, so the selection stays small.
export default gql`
  mutation changeReviewQuestionMutation(
    $complianceProgramId: Int!
    $assessmentTemplateId: Int!
    $action: ReviewQuestionAction!
    $questionSetId: Int
    $sectionId: Int
    $questionId: Int
    $title: String
    $description: JSONString
    $scope: ReviewQuestionWordingScope
  ) {
    changeReviewQuestion(
      complianceProgramId: $complianceProgramId
      assessmentTemplateId: $assessmentTemplateId
      action: $action
      questionSetId: $questionSetId
      sectionId: $sectionId
      questionId: $questionId
      title: $title
      description: $description
      scope: $scope
    ) {
      changed
      assessmentTemplate {
        id
      }
    }
  }
`;
